let lockCount = 0;
let savedScrollY = 0;
let savedHtmlOverflow = "";
let savedBodyOverflow = "";
let savedBodyPosition = "";
let savedBodyTop = "";
let savedBodyWidth = "";

export const acquireBodyScrollLock = (): (() => void) => {
  if (lockCount === 0) {
    savedScrollY = window.scrollY;
    const { documentElement, body } = document;

    savedHtmlOverflow = documentElement.style.overflow;
    savedBodyOverflow = body.style.overflow;
    savedBodyPosition = body.style.position;
    savedBodyTop = body.style.top;
    savedBodyWidth = body.style.width;

    documentElement.style.overflow = "hidden";
    body.style.overflow = "hidden";
    body.style.position = "fixed";
    body.style.top = `-${savedScrollY}px`;
    body.style.width = "100%";
  }

  lockCount += 1;

  return () => {
    lockCount = Math.max(0, lockCount - 1);

    if (lockCount === 0) {
      const { documentElement, body } = document;
      documentElement.style.overflow = savedHtmlOverflow;
      body.style.overflow = savedBodyOverflow;
      body.style.position = savedBodyPosition;
      body.style.top = savedBodyTop;
      body.style.width = savedBodyWidth;
      window.scrollTo(0, savedScrollY);
    }
  };
};
